<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h2 class="text-xl font-medium leading-8 tracking-wide text-gray-900 m-0">
      Features
    </h2>
    <div class="flex items-center gap-2">
      <button mat-button class="add-button" (click)="onAddNew()">
        <mat-icon>add_circle</mat-icon>
        <span>Add New</span>
      </button>
      @if (projectId && !loading()) {
        <button
          mat-icon-button
          (click)="refresh()"
          matTooltip="Refresh features"
          class="action-menu-button"
        >
          <mat-icon>refresh</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (!projectId) {
    <mat-card
      class="border border-blue-100 rounded-lg shadow-sm overflow-hidden p-0"
    >
      <div class="flex flex-col justify-center items-center py-10 gap-4">
        <mat-icon class="text-gray-400 text-5xl">info</mat-icon>
        <p class="text-gray-600 text-center m-0">
          Please select a project to manage features.
        </p>
      </div>
    </mat-card>
  }

  @if (projectId && error()) {
    <mat-card
      class="border border-blue-100 rounded-lg shadow-sm overflow-hidden p-0"
    >
      <div class="flex flex-col justify-center items-center py-10 gap-4">
        <mat-icon class="text-red-500 text-5xl">error</mat-icon>
        <p class="text-red-600 text-center m-0">{{ error() }}</p>
        <button
          mat-stroked-button
          color="primary"
          (click)="refresh()"
          class="mt-2"
        >
          Try Again
        </button>
      </div>
    </mat-card>
  }

  @if (projectId && !error()) {
    <mat-card
      class="border border-blue-100 rounded-lg shadow-sm overflow-hidden p-0"
    >
      @if (loading()) {
        <div class="flex flex-col justify-center items-center py-10 gap-4">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="text-gray-600 text-center m-0">Loading features...</p>
        </div>
      }
      @if (!loading() && dataSource.data.length === 0) {
        <div class="flex flex-col justify-center items-center py-10 gap-4">
          <mat-icon class="text-gray-400 text-5xl">feature_search</mat-icon>
          <p class="text-gray-600 text-center m-0">
            No features available for this project.
          </p>
        </div>
      }
      @if (!loading() && dataSource.data.length > 0) {
        <table mat-table [dataSource]="dataSource" matSort class="w-full">
          <!-- Feature Name Column -->
          <ng-container matColumnDef="featureName">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="table-header"
            >
              Feature Name
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell">
              {{ element.displayName }}
            </td>
          </ng-container>
          <!-- Enabled Column -->
          <ng-container matColumnDef="enabled">
            <th mat-header-cell *matHeaderCellDef class="table-header-center">
              Status
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell-center">
              <mat-checkbox
                [checked]="element.enabled"
                [disabled]="loading()"
                (change)="onToggleFeature(element)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="data-row"
          ></tr>
        </table>
      }
    </mat-card>
  }
</div>
